import React, { useState } from 'react';
import { useMarketMenu } from '../../markets/marketMapping';
import { MoreLessToggleIcon } from '../custom/MoreLessToggleIcon';
import { hex2rgba } from '../../utils/ColorUtils';
import { SportTitle } from '../CommonSportDisplay/common/SportTitle';
import { Visible } from '../../utils/Visible';
import { MarketSelectionMenu, MobileMarketGroups } from '../CommonSportDisplay/desktop/Sport/MarketSelectionMenu';
import { LevelProps } from './types';

export interface ToggleSportProps {
    toggleSport: (sportId: number) => void;
}

interface SportProps extends LevelProps, ToggleSportProps {
}

export const SportWrapper: React.FC<SportProps> = (props) => {
    const { id, tree } = props;
    const sportCount = React.useMemo(() => {
        return tree.l.filter(level => level.l === 'FIXTURE' && level.si === id).length
    }, [tree.l, id])
    if (sportCount === 0) {
        return <></>;
    }
    return <SportBasic {...props} sportCount={sportCount} />;
};

const SportBasic: React.FC<SportProps & { sportCount: number }> = (props) => {
    const { id, tree, sportCount, toggleSport } = props;
    const { currentMarketGroup, marketGroupItems, updateMarketGroupItems, setCurrentMarketGroup } = useMarketMenu(id);
    const [expandSports, setExpandSports] = useState(true);

    function toggleExpandSports() {
        setExpandSports(prevState => !prevState);
        toggleSport(id);
    }

    const sport = tree.s[id];
    return (
        <div className="flex flex-grow-[2] basis-0 w-full">

            <div className="w-full">
                <div className={`pl-[15px] pr-[15px] bg-[#171a1e] items-center notebook:grid max-notebook:flex max-notebook:justify-between h-[37px] tablet:h-[56px] max-tablet:mx-[-16px] mt-[8px] grid-cols-[29px_1fr] max-tablet:bg-[#214A32] notebook:grid-cols-[repeat(2,max-content)] notebook:justify-between`}>
                    <div className="inline-flex">
                        <MoreLessToggleIcon
                            isOpen={expandSports}
                            onClick={toggleExpandSports}
                            color={hex2rgba(sport.sc, .75)}
                        />
                        <SportTitle
                            sportCount={sportCount}
                            color={sport.sc}
                            imageUrl={sport.siu}
                            sportName={sport.sn}
                        />
                    </div>
                    <Visible value={!sport.cl}>
                        {marketGroupItems.length === 1 && <div />}
                        <div className="max-tablet:hidden">
                            <MarketSelectionMenu
                                open={true}
                                marketGroupItems={marketGroupItems}
                                updateMarketGroupItems={updateMarketGroupItems}
                                color={sport.sc}
                            />
                        </div>
                    </Visible>

                </div>


                <div className="tablet:hidden relative">
                    <Visible value={!sport.cl}>
                        <MobileMarketGroups
                            marketGroupItems={marketGroupItems}
                            currentMarketGroup={currentMarketGroup}
                            color={sport.sc}
                            callback={setCurrentMarketGroup}
                        />
                    </Visible>
                </div>
                <div id="to-scroll" />
            </div>
        </div>
    );
};